class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
        FacetFiltersForm.closeMobileDrawerAfterRender();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
    FacetFiltersForm.closeMobileDrawerAfterRender();
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    // Yeni eklenen tm-lazy görselleri hemen observe et
    if (window.tmLazy && window.tmLazy.initImageLazyLoad) {
      window.tmLazy.initImageLazyLoad();
    }

    // Re-relocate any sheets that came in via the new HTML (in case grid had its own copy)
    if (window.__bottomSheetController) {
      window.__bottomSheetController.relocateWrapper();
    }
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
    FacetFiltersForm.updateBottomSheetBadge();
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    FacetFiltersForm.updateBottomSheetBadge();

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      const domEl = document.querySelector(selector);
      if (domEl) domEl.innerHTML = html.querySelector(selector).innerHTML;
    });

    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    if (mobileForm) {
      const menuDrawer = mobileForm.closest('menu-drawer');
      if (menuDrawer && typeof menuDrawer.bindEvents === 'function') {
        menuDrawer.bindEvents();
      }
    }
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static closeMobileDrawerAfterRender() {
    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    if (!mobileForm) return;

    const menuDrawer = mobileForm.closest('menu-drawer');
    if (menuDrawer) {
      const mainDetails = menuDrawer.querySelector('details');
      if (mainDetails && !mainDetails.classList.contains('menu-opening')) {
        document.body.classList.remove('overflow-hidden-mobile');
        document.body.style.overflow = '';
      }
    }

    const bottomSheet = mobileForm.closest('.bottomsheet');
    if (bottomSheet && bottomSheet.classList.contains('is-open')) {
      document.body.style.overflow = '';
    }
  }

  static updateBottomSheetBadge() {
    const filterBtn = document.querySelector('[data-bottomsheet-target="filter"]');
    if (!filterBtn) return;
    const activeCount = document.querySelectorAll('#FacetFiltersFormMobile input[type="checkbox"]:checked').length;
    let badge = filterBtn.querySelector('.bottomsheet-trigger__badge');
    if (activeCount > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'bottomsheet-trigger__badge';
        filterBtn.appendChild(badge);
      }
      badge.textContent = activeCount;
    } else if (badge) {
      badge.remove();
    }
    const applyBtn = document.querySelector('[data-bottomsheet-apply="filter"]');
    if (applyBtn) {
      const countEl = document.getElementById('ProductCount');
      if (countEl) {
        const countText = countEl.textContent.trim();
        const match = countText.match(/(\d+)/);
        if (match) {
          applyBtn.textContent = match[1] + ' Ürün Göster';
        }
      }
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const currentFormId = event.target.closest('form').id;
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else if (currentFormId === 'FacetSortFormMobile' || currentFormId === 'FacetFiltersFormMobile') {
      const forms = [];
      sortFilterForms.forEach((form) => {
        if (form.id === 'FacetFiltersFormMobile' || form.id === 'FacetSortFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    } else {
      const forms = [];
      sortFilterForms.forEach((form) => {
        if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

/* =============================================
   Bottom Sheet Controller
   ============================================= */
class BottomSheetController {
  constructor() {
    this.activeSheetId = null;
    this.startY = 0;
    this.currentY = 0;
    this.isDragging = false;
    this.dragSheet = null;

    this.relocateWrapper();

    document.body.classList.remove('bottomsheet-open');
    document.body.style.overflow = '';
    document.querySelectorAll('.bottomsheet').forEach((s) => {
      s.classList.remove('is-open');
      s.style.transform = '';
    });
    const backdrop = document.querySelector('[data-bottomsheet-backdrop]');
    if (backdrop) backdrop.classList.remove('is-visible');

    this.bindAll();
  }

  relocateWrapper() {
    // Move bottom sheets + backdrop to body so they survive ProductGridContainer re-renders.
    // Trigger buttons stay in place inside the grid container.
    let portal = document.getElementById('bottomsheet-portal');
    if (!portal) {
      portal = document.createElement('div');
      portal.id = 'bottomsheet-portal';
      document.body.appendChild(portal);
    }

    // Find sheets that came in via the new page render (still inside grid container)
    const incomingSheets = document.querySelectorAll(
      '.mobile-facets__wrapper--bs .bottomsheet, .mobile-facets__wrapper--bs [data-bottomsheet-backdrop]'
    );

    if (incomingSheets.length > 0) {
      // New sheets arrived: replace the old portal contents with the new ones
      portal.innerHTML = '';
      incomingSheets.forEach((el) => {
        portal.appendChild(el);
      });
    }
    // If no incoming sheets, keep existing portal contents (already in body, working)
  }

  get backdrop() {
    return document.querySelector('[data-bottomsheet-backdrop]');
  }

  get activeSheet() {
    if (!this.activeSheetId) return null;
    return document.querySelector(`[data-bottomsheet="${this.activeSheetId}"]`);
  }

  bindAll() {
    document.addEventListener('click', this.onDocumentClick.bind(this));
    document.addEventListener('change', this.onDocumentChange.bind(this));
    document.addEventListener('touchstart', this.onTouchStart.bind(this), { passive: true });
    document.addEventListener('touchmove', this.onTouchMove.bind(this), { passive: true });
    document.addEventListener('touchend', this.onTouchEnd.bind(this), { passive: true });
  }

  onDocumentClick(e) {
    const trigger = e.target.closest('[data-bottomsheet-target]');
    if (trigger) {
      e.preventDefault();
      const target = trigger.getAttribute('data-bottomsheet-target');
      const sheet = document.querySelector(`[data-bottomsheet="${target}"]`);
      if (sheet) this.open(sheet);
      return;
    }

    if (e.target.closest('[data-bottomsheet-close]')) {
      if (this.activeSheet) this.close(this.activeSheet);
      return;
    }

    if (e.target.closest('[data-bottomsheet-apply]')) {
      if (this.activeSheet) this.close(this.activeSheet);
      return;
    }

    if (e.target.closest('[data-bottomsheet-backdrop]')) {
      if (this.activeSheet) this.close(this.activeSheet);
      return;
    }
  }

  onDocumentChange(e) {
    if (!e.target.classList || !e.target.classList.contains('bottomsheet__sort-radio')) return;
    document.querySelectorAll('.bottomsheet__sort-option').forEach((opt) => {
      const input = opt.querySelector('input');
      if (input) opt.classList.toggle('active', input.checked);
    });
    setTimeout(() => {
      if (this.activeSheet) this.close(this.activeSheet);
    }, 200);
  }

  onTouchStart(e) {
    const handle = e.target.closest('[data-bottomsheet-handle]');
    if (!handle) return;
    this.dragSheet = handle.closest('.bottomsheet');
    if (!this.dragSheet) return;
    this.startY = e.touches[0].clientY;
    this.isDragging = true;
    this.dragSheet.classList.add('is-dragging');
  }

  onTouchMove(e) {
    if (!this.isDragging || !this.dragSheet) return;
    this.currentY = e.touches[0].clientY;
    const deltaY = this.currentY - this.startY;
    if (deltaY > 0) {
      this.dragSheet.style.transform = `translateY(${deltaY}px)`;
    }
  }

  onTouchEnd() {
    if (!this.isDragging || !this.dragSheet) return;
    this.isDragging = false;
    this.dragSheet.classList.remove('is-dragging');
    const deltaY = this.currentY - this.startY;
    this.dragSheet.style.transform = '';
    if (deltaY > 80) {
      this.close(this.dragSheet);
    }
    this.startY = 0;
    this.currentY = 0;
    this.dragSheet = null;
  }

  open(sheet) {
    document.querySelectorAll('.bottomsheet.is-open').forEach((s) => {
      if (s !== sheet) {
        s.classList.remove('is-open');
        s.removeAttribute('aria-hidden');
        s.inert = true;
      }
    });
    const sheetId = sheet.dataset.bottomsheet;
    this.activeSheetId = sheetId;
    sheet.removeAttribute('aria-hidden');
    sheet.inert = false;
    this.savedScrollY = window.scrollY;
    document.body.style.top = `-${this.savedScrollY}px`;
    document.body.classList.add('bottomsheet-open');
    const backdrop = this.backdrop;
    if (backdrop) backdrop.classList.add('is-visible');
    sheet.classList.add('is-open');
    const trigger = document.querySelector(`[data-bottomsheet-target="${sheetId}"]`);
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  }

  close(sheet) {
    if (document.activeElement && typeof document.activeElement.blur === 'function') {
      const focusedSheet = document.activeElement.closest('.bottomsheet');
      if (focusedSheet) document.activeElement.blur();
    }
    const targetSheet = sheet || this.activeSheet;
    if (targetSheet) {
      targetSheet.classList.remove('is-open');
      targetSheet.removeAttribute('aria-hidden');
      targetSheet.inert = true;
      targetSheet.style.transform = '';
    }
    document.querySelectorAll('.bottomsheet.is-open').forEach((s) => {
      s.classList.remove('is-open');
      s.removeAttribute('aria-hidden');
      s.inert = true;
      s.style.transform = '';
    });
    const backdrop = this.backdrop;
    if (backdrop) backdrop.classList.remove('is-visible');
    document.body.classList.remove('bottomsheet-open');
    document.body.style.overflow = '';
    document.body.style.top = '';
    if (typeof this.savedScrollY === 'number') {
      window.scrollTo(0, this.savedScrollY);
      this.savedScrollY = null;
    }
    if (this.activeSheetId) {
      const trigger = document.querySelector(`[data-bottomsheet-target="${this.activeSheetId}"]`);
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }
    this.activeSheetId = null;
  }
}

function initBottomSheetController() {
  if (window.__bottomSheetController) return;
  window.__bottomSheetController = new BottomSheetController();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBottomSheetController);
} else {
  initBottomSheetController();
}
